<template>
  <div class="disclaimer-checkout">
    <vb-checkbox
      v-model="checked"
      :vb_options="{
        type: 'light',
        size: 'lg',
        text: 'Ho preso visione delle indicazioni di sicurezza e delle normative doganali e sanitarie di accesso a questa destinazione sul sito <a href=\'https://www.viaggiaresicuri.it\' target=\'_blank\'>Viaggiare sicuri</a> del Ministero degli esteri italiano.',
      }"
    />
  </div>
</template>

<script>
export default {
  name: "disclaimer-checkout",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.disclaimer-checkout {
  margin-top: $grid-gutter-width;

  ::v-deep .vb-check__title {
    line-height: normal;
    overflow: hidden;
    font-size: $font-size-md;
  }

  ::v-deep .vb-check {
    margin-bottom: 0;
  }

  ::v-deep .vb-check__title a {
    text-decoration: underline;
  }
}
</style>
